/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { OnboardingAzureResourceGroup } from '../models/OnboardingAzureResourceGroup';

export class AzureListResourceGroupsResponse {
  'resourceGroups'?: Array<OnboardingAzureResourceGroup>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "resourceGroups",
      "baseName": "resourceGroups",
      "type": "Array<OnboardingAzureResourceGroup>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureListResourceGroupsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

